export const build = { date:"2026-02-27.1146", stage:"alpha" }
